var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('v-text-field',{attrs:{"suffix":_vm.suffix,"value":_vm.value,"label":_vm.label,"prefix":_vm.prefix,"rules":_vm.rules},on:{"input":_vm.handleInput}}),_c('tooltip',{attrs:{"left":""}},[_vm._t("tooltip")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }